import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateNotificationService } from '../../services/update-notification/update-notification.service';

@Component({
  selector: 'app-update-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (updateService.notification$ | async; as notification) {
    <div class="update-notification">
      <div class="update-content">
        <div class="update-icon">🔄</div>
        <div class="update-text">
          <h4>Ny version tilgængelig</h4>
          <p>Klik for at opdatere til den nyeste version</p>
        </div>
        <div class="update-actions">
          <button class="update-button" (click)="applyUpdate()">Opdater</button>
          <button class="dismiss-button" (click)="dismiss()">✕</button>
        </div>
      </div>
    </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .update-notification {
        position: fixed;
        top: 70px;
        right: 20px;
        z-index: 9999;
        background: #ffffff;
        border: 1px solid #e1e5e9;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        max-width: 350px;
        animation: slideIn 0.3s ease-out;
      }

      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }

      .update-content {
        display: flex;
        align-items: center;
        padding: 16px;
        gap: 12px;
      }

      .update-icon {
        font-size: 24px;
        flex-shrink: 0;
      }

      .update-text {
        flex: 1;
      }

      .update-text h4 {
        margin: 0 0 4px 0;
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
      }

      .update-text p {
        margin: 0;
        font-size: 12px;
        color: #666;
      }

      .update-actions {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .update-button {
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        transition: background 0.2s;
      }

      .update-button:hover {
        background: #0056b3;
      }

      .dismiss-button {
        background: none;
        border: none;
        color: #666;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        font-size: 14px;
      }

      .dismiss-button:hover {
        background: #f5f5f5;
      }

      @media (max-width: 768px) {
        .update-notification {
          top: 60px;
          right: 10px;
          left: 10px;
          max-width: none;
        }
      }
    `,
  ],
})
export class UpdateNotificationComponent {
  public updateService = inject(UpdateNotificationService);

  applyUpdate(): void {
    this.updateService.applyUpdate();
  }

  dismiss(): void {
    this.updateService.dismissNotification();
  }
}
